import { render, staticRenderFns } from "./ListPageGen.vue?vue&type=template&id=1a2c782a&"
import script from "./ListPageGen.vue?vue&type=script&lang=js&"
export * from "./ListPageGen.vue?vue&type=script&lang=js&"
import style0 from "./ListPageGen.vue?vue&type=style&index=0&id=1a2c782a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports